import axios from 'util/axiosConfig';

export const QUILLR_IFRAME_URL_KEY = 'quillrIframeUrl';
export const QUILLR_SESSION_READY_EVENT = 'quillr-session-ready';

export const checkReportGeneratedByClarityAI = async (visitNo) => {
    const response = await axios.get('/api/v1/ai/checkReportGeneratedByClarityAI', {
        params: { visitNo },
    });
    return response.data === true;
};

export const activateQuillrUserAPI = async (userId) => {
    const response = await axios.post('/api/v1/quillr/activate-user', undefined, { params: { userId } });
    if (response.status !== 200) {
        throw new Error('Unable to activate Quillr. Please try again.');
    }
    return response.data;
};

export const createQuillrSession = async () => {
    const response = await axios.post('/api/v1/quillr/sessions', undefined, {
        timeout: 15000,
        skipAuthSignOut: true,
    });
    const url = response.data && response.data.iframe_url;
    if (!url || typeof url !== 'string' || new URL(url).protocol !== 'https:') {
        throw new Error('Clarity Scribe session URL is unavailable.');
    }
    // UI options are configured on the vendor profile by Quillr (integration guide, section 5).
    return url;
};

let renewal = null;

// Login and reconnect share one request, scoped to the current application login.
export const renewQuillrSession = () => {
    const sessionId = sessionStorage.getItem('USESSIONID');
    if (!sessionId) return Promise.reject(new Error('Please sign in to use Clarity Scribe.'));
    if (renewal && renewal.sessionId === sessionId) return renewal.promise;
    const request = { sessionId };
    request.promise = createQuillrSession().then(url => {
        if (sessionStorage.getItem('USESSIONID') !== sessionId) {
            throw new Error('The signed-in session changed.');
        }
        sessionStorage.setItem(QUILLR_IFRAME_URL_KEY, url);
        window.dispatchEvent(new Event(QUILLR_SESSION_READY_EVENT));
        return url;
    }).finally(() => {
        if (renewal === request) renewal = null;
    });
    renewal = request;
    return request.promise;
};
